import React, { useState } from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  margin-top: 1rem;
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  background-color: #d9534f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 1rem;
`;

const RejectionModal = ({ orderId, onSubmit, onClose }) => {
    const [reason, setReason] = useState('');

    return (
        <ModalBackdrop onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={onClose}><FaTimes /></CloseButton>
                <h3>Reject Order: {orderId}</h3>
                <p>Please provide a reason for rejecting this request. This will be sent to the customer.</p>
                <StyledTextArea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g., Insufficient evidence provided, request is clinically inappropriate..." />
                <SubmitButton onClick={() => onSubmit(orderId, reason)} disabled={!reason.trim()}>Confirm Rejection</SubmitButton>
            </ModalContent>
        </ModalBackdrop>
    );
};

export default RejectionModal;